import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, vShow as _vShow, createVNode as _createVNode, withDirectives as _withDirectives, normalizeClass as _normalizeClass, unref as _unref, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-595b2a0e"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "manage" }
const _hoisted_2 = { class: "manage_title" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "支持拖拽排序及删除", -1))
const _hoisted_4 = ["onClick"]
const _hoisted_5 = { class: "manage_btn" }

import { ref, withDefaults } from 'vue';
import emitter from '../../../utils/mitt';
import draggable from 'vuedraggable';
import CDelModal from '@/components/CDelModal.vue';
import { dragDrop } from '@/utils/format/dragDrop';

interface Props {
  custom: any;
}

export default /*#__PURE__*/_defineComponent({
  __name: 'Manage',
  props: {
    custom: { default: '' }
  },
  setup(__props: any) {

const props = __props as { custom: any };



const visualizationList: any = ref([]);
visualizationList.value = [...props.custom.visualizationList];

const clickId = ref();
const clickList = (index: number) => {
  clickId.value = index;
};

// 删除模块
const deleteModal = ref(false);
const deleteIndex = ref(0);
const deleteList = (index: number) => {
  deleteModal.value = true;
  deleteIndex.value = index;
};
const deteleSelect = () => {
  visualizationList.value.splice(deleteIndex.value, 1);
  deleteModal.value = false;
  emitter.emit('visualizationList', visualizationList.value);
};
const closeModal = () => {
  deleteModal.value = false;
};

const toVisualizationList = async (e: any) => {
  await resetList(e);
  emitter.emit('visualizationList', visualizationList.value);
};

// 首个轮播图、魔方导航置顶
const resetList = (e: any) => {
  return new Promise((resolve) => {
    const RotationChartFind = visualizationList.value.findIndex((item: any) => {
      return item.type == 0;
    });
    const navigation = visualizationList.value.findIndex((item: any) => {
      return item.type == 1;
    });
    let copeList = visualizationList.value;
    const RotationChartFindList = visualizationList.value[RotationChartFind];
    const navigationList = visualizationList.value[navigation];
    //同时存在轮播图和魔方导航
    if (RotationChartFind !== -1 && navigation !== -1) {
      delete copeList[RotationChartFind];
      delete copeList[navigation];
      copeList = copeList.filter((res: any) => {
        return res !== 'undefined';
      });
      e.oldIndex > 1 && e.newIndex > 1 ? resolve(true) : resolve(false);
      visualizationList.value = [...copeList];
      visualizationList.value.unshift(RotationChartFindList);
      visualizationList.value.splice(1, 0, navigationList);
    } //仅存在轮播图
    else if (RotationChartFind !== -1) {
      delete copeList[RotationChartFind];
      copeList = copeList.filter((res: any) => {
        return res !== 'undefined';
      });
      e.oldIndex > 0 && e.newIndex > 0 ? resolve(true) : resolve(false);
      visualizationList.value = [...copeList];
      visualizationList.value.unshift(RotationChartFindList);
    } //仅存在魔方导航
    else if (navigation !== -1) {
      delete copeList[navigation];
      copeList = copeList.filter((res: any) => {
        return res !== 'undefined';
      });
      e.oldIndex > 0 && e.newIndex > 0 ? resolve(true) : resolve(false);
      visualizationList.value = [...copeList];
      visualizationList.value.unshift(navigationList);
    }
  });
};

return (_ctx: any,_cache: any) => {
  const _component_svg_icon = _resolveComponent("svg-icon")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createElementVNode("div", null, "共计：" + _toDisplayString(visualizationList.value.length) + "个", 1)
    ]),
    _createVNode(_unref(draggable), {
      list: visualizationList.value,
      group: { name: 'subassembly' },
      "item-key": "id",
      animation: 150,
      onEnd: toVisualizationList,
      onDrop: _unref(dragDrop)
    }, {
      item: _withCtx(({ element, index }) => [
        _createElementVNode("div", {
          class: _normalizeClass(["manage_list", clickId.value == index ? 'manage_list_border' : '']),
          onClick: ($event: any) => (clickList(index))
        }, [
          _createElementVNode("div", _hoisted_5, _toDisplayString(element.name), 1),
          _withDirectives(_createVNode(_component_svg_icon, {
            onClick: ($event: any) => (deleteList(index)),
            class: "manage_delete",
            "icon-class": "delete_circular"
          }, null, 8, ["onClick"]), [
            [_vShow, clickId.value == index]
          ])
        ], 10, _hoisted_4)
      ]),
      _: 1
    }, 8, ["list", "onDrop"]),
    _createVNode(CDelModal, {
      visible: deleteModal.value,
      centered: "",
      close: closeModal,
      ok: deteleSelect
    }, null, 8, ["visible"])
  ]))
}
}

})